import { render, staticRenderFns } from "./import-setting.vue?vue&type=template&id=107b8458&"
import script from "./import-setting.vue?vue&type=script&lang=js&"
export * from "./import-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports